import { I } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-link-banner',
    templateUrl: './link-banner.component.html',
    standalone: false
})
export class LinkBannerComponent implements OnInit {
    @Input()
    routerLink: string;
    @Input()
    externalUrl: string;
    @Input()
    icon: string = "#sx-chevron_right";
    @Input()
    disabled: boolean;
    @Input()
    matTooltipText: string;
    @Input()
    labelIcon: string;
    @Input()
    trackClick: boolean = false;
    @Input()
    trackClickAction: string;

    @Output()
    onNavigate = new EventEmitter<void>();

    hasLabelIcon = false;

    constructor(private router: Router){

    }

    ngOnInit(): void {

        this.hasLabelIcon = this.labelIcon ? true : false;

    }

    navigate(){
        if (this.routerLink){
            this.router.navigate([this.routerLink]);
            return;
        }
        if (this.externalUrl){
            window.location.href = this.externalUrl;
            return;
        }

        this.onNavigate.emit();
    }
}